import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=c187ad9e&scoped=true&"
import script from "./Simulation.vue?vue&type=script&lang=js&"
export * from "./Simulation.vue?vue&type=script&lang=js&"
import style0 from "./Simulation.vue?vue&type=style&index=0&id=c187ad9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c187ad9e",
  null
  
)

export default component.exports